<template>
  <div class="star-rating-display">
    <template v-if="row">
      <div class="star-rating-display-inner">
        <div
          class="star-rating"
          :title="titleDisplay"
        >
          <div
            v-for="(star, index) in stars"
            :key="index"
            class="star-container"
          >
            <div class="star">
              <div
                class="star-inner"
                :style="`--star-value: ${star.percent}%`"
              />
            </div>
          </div>

          <div
            v-if="isIndicatorActive"
            class="indicator"
          >
            {{ rating }}
          </div>
          <div
            v-if="hasRatingAmount"
            class="rating"
            :title="pluralDisplay"
          >
            ({{ ratingAmount }})
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="star-rating-display-inner star-column">
        <h3>{{ rating }}</h3>
        <div
          class="star-rating"
          :title="titleDisplay"
        >
          <div
            v-if="isIndicatorActive"
            class="indicator"
          >
            {{ rating }}
          </div>
          <div
            v-for="(star, index) in stars"
            :key="index"
            class="star-container"
          >
            <div class="star">
              <div
                class="star-inner"
                :style="`--star-value: ${star.percent}%`"
              />
            </div>
          </div>
        </div>
        <div
          v-if="hasRatingAmount"
          class="rating"
          :title="pluralDisplay"
        >
          {{ pluralDisplay }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'stars-rating',
  components: {},
  props: {
    row: {
      Boolean,
      required: false,
      default: false
    },
    rating: {
      type: Number,
      required: true
    },
    ratingAmount: {
      type: Number,
      required: true
    },
    totalStars: {
      type: Number,
      required: false,
      default: 5
    }
  },

  data: function() {
    return {
      stars: [],
      emptyStar: 0,
      fullStar: 1,
      isIndicatorActive: false
    }
  },
  computed: {
    hasRatingAmount() {
      if (this.ratingAmount >= 1) {
        return true
      }
    },
    pluralDisplay() {
      const amount = this.ratingAmount
      const label = 'Rating'
      const pluralize = (count, noun, suffix = 's') =>
        `${count} ${noun}${count !== 1 ? suffix : ''}`
      return pluralize(amount, label)
    },
    titleDisplay() {
      const pluralize = (count, noun, suffix = 's') =>
        `${count} ${noun}${count !== 1 ? suffix : ''}`
      return pluralize(this.rating, 'Star')
    }

  },
  created() {
    this.initStars()
    this.setStars()
  },

  methods: {
    initStars() {
      for (let i = 0; i < this.totalStars; i++) {
        this.stars.push({
          raw: this.emptyStar,
          percent: this.emptyStar
        })
      }
    },
    setStars() {
      let fullStarsCounter = Math.floor(this.rating)
      for (let i = 0; i < this.stars.length; i++) {
        if (fullStarsCounter !== 0) {
          this.stars[i].raw = this.fullStar
          this.stars[i].percent = this.calcStarFullness(this.stars[i])
          fullStarsCounter--
        }
        else {
          let surplus = Math.round((this.rating % 1) * 10) / 10 // Support just one decimal
          let roundedOneDecimalPoint = Math.round(surplus * 10) / 10
          this.stars[i].raw = roundedOneDecimalPoint
          return (this.stars[i].percent = this.calcStarFullness(this.stars[i]))
        }
      }
    },
    calcStarFullness(starData) {
      let starFullnessPercent = starData.raw * 100
      return starFullnessPercent
    },
    setBindedProp(localProp, propParent, propToBind) {
      if (propParent[propToBind]) {
        localProp[propToBind] = propParent[propToBind]
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
.star-rating-display-inner {
  display: flex;
  &.star-row {
    flex-direction: row;
  }
  &.star-column {
    flex-direction: column;
  }
}
.star-rating {
  --star-size: 1em;
  --star-color: #ffc107;
  --star-background-color: #e1e1e1;
}
.rating {
  font-size:.8em;
}
.star-rating {
  display: flex;
  align-items: center;
  justify-content: center;

  .star-container:not(:last-child) {
    margin-right: 0.25em;
  }
}
//div for star with pologyon clip path for the shape
.star {
  position: relative;
  width: var(--star-size);
  height: var(--star-size);
  background: var(--star-background-color);
/*   clip-path: polygon(
    50% 0%,
    62% 36%,
    100% 36%,
    69% 58%,
    81% 95%,
    50% 72%,
    19% 95%,
    31% 58%,
    0% 36%,
    38% 36%
  ); */

  //thicker star
  clip-path: polygon(50% 0%,
  65% 30%,
  100% 35%,
  75% 57%,
  80% 91%,
  50% 75%,
  20% 91%,
  25% 57%,
  0% 35%,
  35% 30%);
}

//we get the content width for each star from star.percent
.star-inner {
  display: block;
  height: var(--star-size);
  top: 0;
  left: 0;
  position: absolute;
  z-index: 22;
  position: relative;
  background: var(--star-color);
  width: var(--star-value);
}
</style>
